import {updateServiceCountData} from "./updateServiceCountData";

export function initServicesSlider() {
    $('.slider-img').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.slider-info',
        nextArrow: '.services .btn-arrow--next',
        prevArrow: '.services .btn-arrow--prev'
    });

    $('.slider-info').slick({
        dots: false,
        arrows: false,
        fade: true,
        infinite: true,
        cssEase: 'linear',
        speed: 500,
        asNavFor: '.slider-img',
    });

    $('.slider-img').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        updateServiceCountData(nextSlide)
    });
}
